import exchangeInterfaceStore from "../../stores/ExchangeInterfaceStore";
import { observer } from "mobx-react";
import { ActiveOption } from "../../types/ExchangeInterface";
import Buy from "./BuySection";
import Claim from "./ClaimSection";
import { ACTIVE_OPTIONS } from "../../utils/constants";
import CountdownCounter from "./Counter";
import presaleStore from "../../stores/PresaleStore";
import { referrerStorage } from "../../utils/helpers";
import { useEffect } from "react";
import { useAccount } from "wagmi";
import ReferralSection from "./ReferralSection";
import { isAddress } from "viem";
import { toast } from "react-toastify";

function ExchangeInterface({
  className,
}: {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}) {
  const { activeOption, setActiveOption, referrer, setReferrer } =
    exchangeInterfaceStore;
  const { presaleData } = presaleStore;
  const { address } = useAccount();

  useEffect(() => {
    const referrerFromQueryParams = new URLSearchParams(
      window.location.search
    ).get("ref");
   
    const storedReferrer = referrerStorage().getReferrer();


    if (storedReferrer && isAddress(storedReferrer)) {
      if (address === storedReferrer) {
        toast.error("Referrer address can't be the same as buyer's");
        return;
      }
      setReferrer(storedReferrer);
      return;
    }

    if (referrerFromQueryParams && isAddress(referrerFromQueryParams)) {
      if (address === referrerFromQueryParams) {
        toast.error("Referrer address can't be the same as buyer's");
        return;
      }
      referrerStorage().setReferrer(referrerFromQueryParams);
      setReferrer(referrerFromQueryParams);
      return;
    }
  }, [referrer, setReferrer, address]);

  return (
    <div className={className}>
      <div
        style={{ backgroundImage: "url(/assets/images/pepe3.jpg)" }}
        className="absolute w-full h-full   bg-center bg-cover opacity-60"
      />
      <div className="relative border rounded-lg  p-2 text-white">
        <div className="flex flex-col  items-center gap-y-2">
          <span className="text-upper font-bold tracking-wide uppercase md:text-lg text-[#fff]">
            buy $PEPE3D before it's late!
          </span>

          <div className="flex flex-col items-center w-full">
            <span className="text-[#fff] font-bold text-lg uppercase tracking-wide">
              Next presale round starts in
            </span>
            <CountdownCounter />
          </div>

          <span className="w-full flex flex-col items-center font-bold  p-2 tracking-wide dashTitle text-neutral-100 text-lg ">
            AMOUNT RAISED {presaleData?.presaleFundsRaised}
          </span>

          <div className="flex w-full border border-gray-300 rounded-md">
            {["BUY", "CLAIM"].map((optionButtonName) => (
              <button
                key={`${optionButtonName}-button`}
                className={`rounded-md py-4 font-bold uppercase flex-1 ${
                  activeOption === optionButtonName &&
                  "shadow-inner shadow-black bg-lime-500 opacity-90"
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveOption(optionButtonName as ActiveOption);
                }}
              >
                <span className="tracking-wide">{optionButtonName}</span>
              </button>
            ))}
          </div>
        </div>

        {/*Second section */}
        {activeOption === ACTIVE_OPTIONS.BUY && <Buy />}
        {activeOption === ACTIVE_OPTIONS.CLAIM && <Claim />}

        {address ? (
          <ReferralSection
            referralLink={`https://pepe3d.live/?ref=${address}`}
          />
        ) : (
          <div className="bg-slate-200/30 p-2 rounded-md mt-2 text-center">
            Connect wallet to see your referral link and tokens.
          </div>
        )}
      </div>
    </div>
  );
}

export default observer(ExchangeInterface);
